module.exports = __webpack_public_path__ + "static/media/AccountMenuIcon.f3870ee2.svg";